(function () {
  const SECTION_SELECTOR =
    '.shopify-section--main-collection, .shopify-section--main-search';

  // Debug logy zapneš v konzole cez: window.CLM_DEBUG = true
  const log = (...args) => {
    if (window.CLM_DEBUG) console.log('[CLM]', ...args);
  };

  // Sekcie, na ktorých už sledujeme výmenu obsahu (facety / triedenie / stránkovanie)
  const watchedSections = new WeakSet();

  function initSection(section) {
    const sectionId = section.id.replace('shopify-section-', '');

    const grid = section.querySelector('#product-list-' + sectionId);
    const paginationWrapper = section.querySelector('#CollectionPagination-' + sectionId);
    const loadMoreBtn = section.querySelector('#CollectionLoadMore-' + sectionId);

    log('init sectionId:', sectionId, 'grid:', !!grid, 'pagination:', !!paginationWrapper, 'btn:', !!loadMoreBtn);

    if (!grid || !paginationWrapper || !loadMoreBtn) return;

    // Ochrana proti dvojitej inicializácii toho istého tlačidla
    if (loadMoreBtn.dataset.clmReady === 'true') return;
    loadMoreBtn.dataset.clmReady = 'true';

    // Skúsime nájsť "next" link – len reálny NEXT, žiadny fallback
    let nextLinkEl =
      paginationWrapper.querySelector('a[rel="next"]') ||
      paginationWrapper.querySelector('.pagination__item--next a');

    if (!nextLinkEl) {
      // žiadna ďalšia stránka -> necháme klasickú pagination, žiadny Load more
      return;
    }

    let nextUrl = nextLinkEl.href;
    let isLoading = false; // 🔐 LOCK, aby sme nevolali loadMore paralelne

    // Skryť pôvodnú pagination a ukázať tlačidlo
    loadMoreBtn.style.display = '';
    paginationWrapper.style.display = 'none';

    async function loadMore() {
      if (!nextUrl || isLoading) return; // ⛔ už neloaďuj, ak práve beží request

      isLoading = true;
      loadMoreBtn.disabled = true;
      loadMoreBtn.classList.add('is-loading');

      try {
        log('loading:', nextUrl);
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Network error');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('#product-list-' + sectionId);
        const newPaginationWrapper = doc.querySelector('#CollectionPagination-' + sectionId);

        if (newGrid) {
          const newItems = Array.from(newGrid.children);

          newItems.forEach((item, index) => {
            // 1) Zrušíme Prestige reveal stav
            item.classList.remove('reveal', 'reveal-item', 'reveal--hidden');
            item.removeAttribute('data-reveal');

            item
              .querySelectorAll('[data-reveal], .reveal, .reveal-item, .reveal--hidden')
              .forEach((el) => {
                el.classList.remove('reveal', 'reveal-item', 'reveal--hidden');
                el.removeAttribute('data-reveal');
                el.style.opacity = '';
                el.style.transform = '';
              });

            // 2) Označíme item ako "nový"
            item.classList.add('clm-new');

            // 3) Pripojíme ho do gridu
            grid.appendChild(item);

            // 4) Animácia so staggerom
            const delay = index * 60;
            setTimeout(() => {
              item.classList.add('clm-new--visible');
            }, delay + 20);
          });

          log('items appended:', newItems.length);

          // ak máš swiper init:
          if (window.initProductCardMobileSwiper) {
            window.initProductCardMobileSwiper(grid);
          }
        }

        if (newPaginationWrapper) {
          let newNextLink =
            newPaginationWrapper.querySelector('a[rel="next"]') ||
            newPaginationWrapper.querySelector('.pagination__item--next a');

          if (newNextLink) {
            const newNextUrl = newNextLink.href;

            // toto už nemusíme riešiť kvôli isLoading,
            // ale nechávam ako extra ochranu – ak by sa niečo pokazilo
            if (newNextUrl === nextUrl) {
              console.warn('[CLM] nextUrl would repeat, stopping load more');
              nextUrl = null;
              loadMoreBtn.style.display = 'none';
            } else {
              nextUrl = newNextUrl;
              loadMoreBtn.disabled = false;
              loadMoreBtn.classList.remove('is-loading');
            }
          } else {
            // Žiadny next link -> posledná stránka
            nextUrl = null;
            loadMoreBtn.style.display = 'none';
          }
        } else {
          // safety: ak by sme nezískali pagination, radšej stopneme
          nextUrl = null;
          loadMoreBtn.style.display = 'none';
        }
      } catch (e) {
        console.error('[CLM] error:', e);
        loadMoreBtn.disabled = false;
        loadMoreBtn.classList.remove('is-loading');
      } finally {
        isLoading = false; // 🔓 uvoľníme lock
      }
    }

    loadMoreBtn.addEventListener('click', loadMore);

    //  infinite scroll – nech volá loadMore len keď NIE JE isLoading
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && nextUrl && !isLoading) {
            loadMore();
          }
        });
      },
      {
        root: null,
        rootMargin: '200px 0px 200px 0px', // trošku buffer, aby sa to spustilo skôr
        threshold: 0,
      }
    );

    // Starý observer (z predchádzajúceho renderu sekcie) odpojíme, nech nám nevisí v pamäti
    if (section.__clmObserver) section.__clmObserver.disconnect();
    section.__clmObserver = observer;

    observer.observe(loadMoreBtn);
  }

  // Prestige pri filtrovaní / triedení / stránkovaní zavolá
  // shopifySection.replaceChildren(...) – teda kompletne vymení obsah sekcie.
  // Preto musíme init spustiť znova zakaždým, keď sa deti sekcie vymenia.
  function watchSection(section) {
    if (watchedSections.has(section)) return;
    watchedSections.add(section);

    const mo = new MutationObserver(() => {
      log('section content replaced, re-init');
      initSection(section);
    });

    // subtree: false – zaujímajú nás len priame deti sekcie (replaceChildren),
    // nie naše vlastné appendChild do gridu (to by spustilo nekonečnú slučku)
    mo.observe(section, { childList: true });
  }

  function initAll(root = document) {
    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      watchSection(section);
      initSection(section);
    });
  }

  function boot() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: sekcia sa znovu vykreslí
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section && section.matches && section.matches(SECTION_SELECTOR)) {
      watchSection(section);
      initSection(section);
    }
  });
})();
